import './App.scss';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {ThemeProvider} from "@mui/material";
import greenTheme from "./components/themes/GreenTheme";

import NotFound from "./pages/404";
import Login from "./pages/authentication/Login";
import {AuthProvider} from "./context/AuthContext";
import {ConfigProvider} from "./context/ConfigContext";
import Dashboard from "./pages/dashboard/Dashboard";
import PrivateRoute from "./utils/PrivateRoute";
import Web from "./pages/website/Web";
import Categories from "./pages/category/Categories";
import Services from "./pages/category/service/Services";
import ServiceDetail from "./pages/category/service/ServiceDetail";
import Colleagues from "./pages/colleague/Colleagues";
import OpeningHours from "./pages/opening-hours/OpeningHours";
import Notifications from "./pages/notification/Notifications";
import Settings from "./pages/settings/Settings";
import Reservations from "./pages/reservation/Reservations";
import ColleagueDetail from "./pages/colleague/ColleagueDetail";
import Register from "./pages/authentication/Registration";
import SuccessfulRegistration from "./pages/authentication/SuccessfulRegistration";
import RegisterExisting from "./pages/authentication/ExistingRegistration";
import CardRegistration from "./pages/authentication/CardRegistration";
import PaymentOver from "./pages/authentication/PaymentOver";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import NewPassword from "./pages/authentication/NewPassword";
import {ErrorProvider} from "./context/ErrorContext";
import ActivationLogin from "./pages/authentication/ActivationLogin";
import ExtraItems from "./pages/extra-items/ExtraItems";
import ExtraItemDetail from "./pages/extra-items/ExtraItemDetail";
import {AuthConfigProvider} from "./context/AuthConfigContext";
import SmsPaymentOver from "./pages/authentication/SmsPaymentOver";
import { LocalizationProvider } from "@mui/x-date-pickers";
import locale from "date-fns/locale/hu";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Orders from "./pages/order/Orders";
import Popup from "./pages/popup/Popup";



function App() {

    return <ThemeProvider theme={greenTheme}>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale}>
            <ConfigProvider>
                <ErrorProvider>
                    <Router>
                        <AuthProvider>
                            <AuthConfigProvider>
                                <Switch>
                                    <PrivateRoute path="/" resource="dashboard" component={Dashboard} exact/>

                                    <PrivateRoute path="/web" resource="website" component={Web} exact/>

                                    <PrivateRoute path="/categories" resource="category" component={Categories} exact/>
                                    <PrivateRoute path="/service/:id" resource="service" component={Services} exact/>
                                    <PrivateRoute path="/service-detail/:id" resource="service" component={ServiceDetail} exact/>

                                    <PrivateRoute path="/extra-items" resource="extraItem" component={ExtraItems} exact/>
                                    <PrivateRoute path="/extra-items/:id" resource="extraItem" component={ExtraItemDetail} exact/>

                                    <PrivateRoute path="/colleagues" resource="user" component={Colleagues} exact/>
                                    <PrivateRoute path="/colleague/:id" resource="user" component={ColleagueDetail} exact/>

                                    <PrivateRoute path="/opening-hours" resource="openingHours" component={OpeningHours} exact/>

                                    <PrivateRoute path="/notifications" resource="notification" component={Notifications} exact/>

                                    <PrivateRoute path="/settings" resource="settings" component={Settings} exact/>

                                    <PrivateRoute path="/reservations" resource="reservation" component={Reservations} exact/>

                                    <PrivateRoute path="/orders" resource="order" component={Orders} exact/>

                                    <PrivateRoute path="/popups" resource="popup" component={Popup} exact/>

                                    <Route path="/login" component={Login} exact/>
                                    {/*<Route path="/activation-login" component={ActivationLogin} exact/>*/}
                                    <Route path="/forgot-password" component={ForgotPassword} exact/>
                                    <Route path="/new-password/:slug" component={NewPassword} exact/>
                                    {/*<Route path="/register" component={Register} exact/>*/}
                                    <Route path="/register-existing/:slug" component={RegisterExisting} exact/>
                                    <Route path="/card-registration" component={CardRegistration} exact/>
                                    <Route path="/payment-over" component={PaymentOver} exact/>
                                    <Route path="/sms-payment-over" component={SmsPaymentOver} exact/>

                                    <Route path="/success" component={SuccessfulRegistration} exact/>
                                    <Route component={NotFound}/>
                                </Switch>
                            </AuthConfigProvider>
                        </AuthProvider>
                    </Router>
                </ErrorProvider>
            </ConfigProvider>
        </LocalizationProvider>
    </ThemeProvider>
}

export default App;